import { Box, Checkbox, Column, Row, Text } from '~/commonComponents';
import { Date as JobDate } from '~/components/Schedule/components/JobCard/components/Date';
import { getJobStatus } from '~/components/Dashboard/ReceiptList/utils';
import { UserProfession, UserSubProfession } from '~/enums/UserProfession';
import { format, parse } from 'date-fns';
import { ChevronRight } from '~/images/icons';
import { Colors } from '~/themes/colors';
import { useNavigate } from 'react-router';

interface IInterviewRowProps {
  date: string;
  endTime: string;
  isSelected: boolean;
  onsiteInterviewId: string;
  profession: string;
  startTime: string;
  status: string;
  subProfession: string | null;
  onToggle: (id: string) => void;
}

export const InterviewRow = ({
  date,
  endTime,
  isSelected,
  onsiteInterviewId,
  profession,
  startTime,
  status,
  subProfession,
  onToggle,
}: IInterviewRowProps) => {
  const navigate = useNavigate();
  const { color, label } = getJobStatus(status);

  return (
    <Row
      alignItems="stretch"
      aria-label={`Interview on ${date}`}
      borderRadius={8}
      className="shadow-xs hover__shadow-sm"
      cursor="pointer"
      data-testid="interview-row"
      gap={12}
      paddingBlock={8}
      paddingInline={20}
      role="button"
      onClick={() => navigate(`/dashboard/job/${onsiteInterviewId}`)}
    >
      <Box
        justifyContent="center"
        paddingInline={12}
        role="button"
        onClick={(e) => {
          e.stopPropagation();
          onToggle(onsiteInterviewId);
        }}
      >
        <Checkbox checked={isSelected} />
      </Box>
      <Row flex={1} gap={12}>
        <JobDate
          backgroundColor={color}
          localDate={format(parse(date, 'EEE, MMM d, yyyy', new Date()), 'yyyy-MM-dd')}
        />
        <Column flex={1}>
          <Text bold>
            {UserSubProfession.getName(subProfession || '') || UserProfession.getName(profession)}
          </Text>
          <Text>
            {startTime} - {endTime}
          </Text>
          <Text color={color}>{label}</Text>
        </Column>
      </Row>
      <Box alignSelf="center">
        <ChevronRight color={Colors.secondary_500} size={24} />
      </Box>
    </Row>
  );
};
